<template>
  <div class="partner-offer">
    <Loading v-if="loadingOffers" />
    <template v-else>
      <FiltersTag
        class="mb-4"
        :filters-tag="availableTags"
        @change-search-params="onChangeSearchParams"
      />
      <PartnerOfferCatalog :offer-list="offerList" />
    </template>
  </div>
</template>

<script>
import PartnerOfferCatalog from '@/components/PartnerOffer/PartnerOfferCatalog.vue';
import FiltersTag from '@/components/FiltersTag/FiltersTag.vue';
import Loading from '@/components/Loading/Loading.vue';

const axios = require('axios');

const NEW_API_URL = window.apiUrl;

export default {
  name: 'PartnerOfferView',
  components: { Loading, FiltersTag, PartnerOfferCatalog },
  data: () => ({
    offerList: null,
    availableTags: null,
    loadingOffers: true,
  }),
  beforeMount() {
    const searchParams = new URLSearchParams(window.location.search).get('filter');
    this.getOfferList(searchParams);
  },
  methods: {
    getOfferList(searchParams) {
      const url = searchParams
        ? `${NEW_API_URL}/partner/offer/list?filter=${searchParams}`
        : `${NEW_API_URL}/partner/offer/list`;
      axios
        .get(url)
        .then((resp) => {
          if (resp.data) {
            this.offerList = resp.data.list || [];
            this.availableTags = resp.data.availableTags;
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loadingOffers = false;
        });
    },
    onChangeSearchParams(searchParams) {
      this.getOfferList(searchParams);
    },
  },
};
</script>

<style lang="scss" scoped>
.partner-offer {
  position: relative;
  min-height: 400px;
}
</style>
